import { formatDate } from "@erp/shared/utils/date/formatted-date";
import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
/**
 * @description 전체 제품 조회용 입력 항목
 */
export const allSearchInputs = [
    {
        label: "종류",
        key: "type",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        list: [PRODUCT_TYPE.원부자재, PRODUCT_TYPE.반제품, PRODUCT_TYPE.완제품],
        clearable: true,
    },
    {
        label: "분류",
        key: "classification",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "4",
        lg: "2",
        clearable: true,
        returnObject: true,
    },
    {
        label: "상태",
        key: "conditions",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        list: ["G", "B"],
        clearable: true,
    },
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "모델명",
        key: "model",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "사양",
        key: "spec",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제조사",
        key: "manufacturer",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
];
export const dateSearchInput = {
    label: "기준일",
    key: "date",
    type: "dateSingle",
    value: formatDate(),
    col: "12",
    sm: "4",
    lg: "3",
};
/**
 * @description 완제품 제외 제품 조회용 입력 항목
 */
export const excludeFinishedGoodSearchInputs = [
    {
        label: "종류",
        key: "type",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: PRODUCT_TYPE.원부자재,
        list: [PRODUCT_TYPE.원부자재, PRODUCT_TYPE.반제품],
    },
    {
        label: "분류",
        key: "classification",
        type: "auto",
        value: "",
        col: "12",
        sm: "4",
        lg: "2",
        clearable: true,
    },
    {
        label: "상태",
        key: "conditions",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        list: ["G", "B"],
        clearable: true,
    },
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "모델명",
        key: "model",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "사양",
        key: "spec",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제조사",
        key: "manufacturer",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
];
/**
 * @description 특정 종류 제품 조회용 입력 항목, ex) 원부자재만 조회하고 싶을 때
 */
export const specficTypeSearchInputs = [
    {
        label: "분류",
        key: "classification",
        type: "auto",
        value: "",
        col: "12",
        sm: "4",
        lg: "2",
        clearable: true,
    },
    {
        label: "상태",
        key: "conditions",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        list: ["G", "B"],
        clearable: true,
    },
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        clearable: true,
    },
    {
        label: "모델명",
        key: "model",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "사양",
        key: "spec",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제조사",
        key: "manufacturer",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
];
/**
 * @description 완제품 조회용 입력 항목
 */
export const finishedGoodSearchInputs = [
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "사양",
        key: "spec",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
];
export const productSelectHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "분류", align: "start", value: "classification" },
    { text: "관리코드", align: "start", value: "productCode" },
    { text: "제품명", align: "start", value: "name" },
    { text: "모델명", align: "start", value: "model" },
    { text: "사양", align: "start", value: "spec" },
    { text: "제조사", align: "start", value: "manufacturer" },
];
export const stockSearchHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "분류", align: "start", value: "classification" },
    { text: "관리코드", align: "start", value: "productCode" },
    { text: "제품명", align: "start", value: "name" },
    { text: "모델명", align: "start", value: "model" },
    { text: "사양", align: "start", value: "spec" },
    { text: "제조사", align: "start", value: "manufacturer" },
    { text: "재고", align: "start", value: "stockNum" },
    { text: "단위", align: "start", value: "quantityUnit" },
    { text: "단가", align: "start", value: "unitPrice" },
    { text: "합계", align: "start", value: "totalPrice" },
];
export const expandHeader = {
    text: "",
    align: "center",
    value: "expander",
};
export const bomSearchHeaders = [
    ...[expandHeader],
    ...productSelectHeaders,
    { text: "필요수량", align: "start", value: "quantity" },
];
/**
 * @description 하위 부품 조회용 테이블 헤더
 */
export const bomSearchWithStockHeaders = [
    ...[expandHeader],
    ...stockSearchHeaders,
    { text: "필요수량", align: "start", value: "quantity" },
];
/**
 * @description 추가 버튼 테이블 헤더
 */
export const actionSearchHeaders = [
    ...stockSearchHeaders,
    { text: "추가", align: "center", value: "actions", sortable: false },
];
/**
 * @description 편집 버튼 테이블 헤더
 */
export const editSearchHeaders = [
    ...stockSearchHeaders,
    { text: "편집", align: "center", value: "actions", sortable: false },
];
